module.exports = __webpack_public_path__ + "img/Boy_030027.820b866a.png";